import * as NoteActivitiesRemote from 'remote/noteActivities'
import { dataFetched } from 'data/graphql'

export const fetchNoteActivities = ({ noteId }) => ({
  graphQLClient,
  dispatch,
}) => ({
  type: 'IGNORE_ME',
  payload: graphQLClient
    .query({
      query: NoteActivitiesRemote.fetchNoteActivities,
      variables: { noteId },
    })
    .then(result => {
      dispatch(dataFetched(result.data.showNote))
    }),
})

export const fetchNoteActivitiesWithContent = ({ noteId }) => ({
  graphQLClient,
  dispatch,
}) => ({
  type: 'IGNORE_ME',
  payload: graphQLClient
    .query({
      query: NoteActivitiesRemote.fetchNoteActivitiesWithContent,
      variables: { noteId },
    })
    .then(result => {
      dispatch(dataFetched(result.data.showNote))
    }),
})
